import { render, staticRenderFns } from "./expireRemind.vue?vue&type=template&id=3274f64c&scoped=true&"
import script from "./expireRemind.vue?vue&type=script&lang=js&"
export * from "./expireRemind.vue?vue&type=script&lang=js&"
import style0 from "./expireRemind.vue?vue&type=style&index=0&id=3274f64c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274f64c",
  null
  
)

export default component.exports